import { createContext, useContext, useEffect } from "react";

export interface SideNavOverride {
  collapsed?: boolean;
  disableExpand?: boolean;
}

interface SideNavOverrideContextType {
  override: SideNavOverride | null;
  setOverride: (override: SideNavOverride | null) => void;
}

export const SideNavOverrideContext = createContext<SideNavOverrideContextType>({
  override: null,
  setOverride: () => {},
});

export function useSideNavOverride() {
  return useContext(SideNavOverrideContext);
}

export function useCollapseSideNav(
  options: SideNavOverride = { collapsed: true, disableExpand: true }
) {
  const { setOverride } = useSideNavOverride();
  useEffect(() => {
    setOverride(options);
    return () => setOverride(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
